import { render, staticRenderFns } from "./Editorg.vue?vue&type=template&id=195c8c78"
import script from "./Editorg.vue?vue&type=script&lang=js"
export * from "./Editorg.vue?vue&type=script&lang=js"
import style0 from "./Editorg.vue?vue&type=style&index=0&id=195c8c78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports